import React from "react";
import { Formik, Form } from "formik";
import { Stack } from "office-ui-fabric-react";
import { useTranslation } from "react-i18next";
import NewFormField from "../../common/layout/form/NewFormField";
import ActivityIndicator from "../../common/layout/ActivityIndicator";
import MessageContainer from "../../auth/components/register/forms/MessageContainer";
import NewFormBtns from "../../common/layout/form/NewFormBtns";

export interface TypeFormProps {
  handleSubmit: any;
  initValues: any;
  cancelForm: any;
  selectedOrderTypes: any;
  loading: any
}

const TypeForm: React.FC<TypeFormProps> = ({ handleSubmit, initValues, cancelForm, selectedOrderTypes, loading}) => {
  const { t } = useTranslation("admin");

  return (
    <Formik
      initialValues={initValues}
      onSubmit={handleSubmit}
      enableReinitialize={true}
    >
      {({ handleSubmit }) => (
        <Form id="form" translate="yes" onSubmit={handleSubmit}>
          <Stack>
            <NewFormField name="typeName" label={t("nav.orderTypeName") as string} />
            <NewFormField name="capacity" label={t("nav.capacityLabel") as string} type="number"/>
            {loading ? <ActivityIndicator /> : <MessageContainer />}
          </Stack>

          <NewFormBtns
              cancelForm={cancelForm}
              submitBtnText={selectedOrderTypes[0] ? t("nav.save") as string : t("nav.add") as string}
              disabled={loading}
              positionAbsolute={true}
            />
        </Form>
      )}
    </Formik>
  );
};

export default TypeForm;
